<template>
    <transition appear name="post-highlight-animation">
        <div
                class="post-highlight-newest absolute card deep-shadow normal-text light-text hover-opacity no-select"
                v-if="singleTopic && !topic.unread && !itemHighlighted && topic.comments().length > 2 && viewType !== 'moodview'"
                @click="showNewest">
            <!--v-scroll-to="'#element'"-->
            <p class="inline-block">{{ translations['social.latest_messages']
                }}</p>
            <i class="fa fa-arrow-down inline-block secondary-c"></i>
        </div>
    </transition>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import Feed from '../../mixins/Feed.js'
    import maxBy from 'lodash.maxby';
    import forEach from 'lodash.foreach';

    export default {
        mixins: [Global,Feed],

        props: {
            singleTopic: {
                default: false
            },
            topic: {
                required: true
            },
            itemHighlighted: {
                default: false
            },
            viewType: {}
        },

        computed: {
            //find the newest item in the topic
            newestItem() {
                let item = false;

                let items = [];

                //add all the comments and replies
                forEach(this.topic.comments(), function (comment) {
                    items.push(comment);

                    forEach(comment.replies(), function (reply) {
                        items.push(reply);
                    });
                });

                //return the one with the newest created_at
                item = maxBy(items, function (item) {
                    return new Date(item.created_at);
                });

                return item;
            },
        },

        methods: {
            //show or hide 'show newest' button
            scrollHandler() {
                let scrolledDown = window.pageYOffset;

                if (scrolledDown >= 75) {
                    this.itemHighlighted = true;
                } else {
                    this.itemHighlighted = false;
                }
            },
        },

        created() {
            let self = this;

            //add scroll listener on load
            if (this.singleTopic && !this.topic.unread && !this.itemHighlighted && this.topic.comments().length > 2) {
                document.addEventListener('scroll', this.scrollHandler);

                const newestSpacebarHandler = (e) => {
                    if (e.keyCode === 32 && !this.itemHighlighted && window.pageYOffset < 75) {
                        e.preventDefault();

                        setTimeout(function() {
                            self.showNewest();
                        }, 100);
                    }
                };

                document.addEventListener(`keydown`, newestSpacebarHandler);

                this.$once(`hook:destroyed`, () => {
                    document.removeEventListener(`keydown`, newestSpacebarHandler);
                });
            }
        }
    }
</script>